import axios from "axios";
import { config_UPTIME } from "../Constants";
import { getItem } from "../utils/DataProtection";
import { getFileExtention } from "../utils/helpers";

// Reference photos per checklist entry ("how it should look"), stored on the
// checklist item as `checklist_item_photos` (uptime-backend MR !16). They
// belong to the checklist definition — not to a report's answers.

// The backend answers 400 above this; the editor never lets it get there.
export const MAX_REFERENCE_PHOTOS = 10;

// What the backend stores per photo. A read photo also carries a signed,
// expiring `url` (and the editor adds a local preview); neither is sent.
export const toStoredPhoto = (photo = {}) => {
  const stored = { fileid: photo.fileid };
  ["bucketid", "mimetype", "fileversion"].forEach(key => {
    if (photo[key] !== undefined && photo[key] !== null) stored[key] = photo[key];
  });
  return stored;
};

/**
 * Upload slots for `files`, all under the checklist's own nodeid — the file
 * links the backend returns on read only resolve for that nodeid.
 * @returns {Promise<Array<{fileid, bucketid, url, fileversion}>>} one per
 *   file, same order
 */
export async function requestPhotoUploadSlots(checklistNodeId, files) {
  const extensions = files.map(file => ({
    nodeid: checklistNodeId,
    extension: getFileExtention(file.type) || "jpg"
  }));
  const { data } = await axios.post(
    `${config_UPTIME.url.API_URL}/files`,
    { count: extensions.length, extensions },
    {
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + JSON.parse(getItem("user"))
      }
    }
  );
  if (!Array.isArray(data) || data.length !== files.length) {
    throw new Error("POST /files returned no upload slot per file");
  }
  return data;
}

/** PUTs the raw bytes to a pre-signed slot URL (no auth header). */
export async function uploadPhotoToSlot(slot, file, onProgress) {
  await axios.put(slot.url, file, {
    headers: { "Content-Type": file.type || "image/jpeg" },
    onUploadProgress: event => {
      if (event.total) onProgress?.(Math.round((event.loaded * 100) / event.total));
    }
  });
  return toStoredPhoto({
    fileid: slot.fileid,
    bucketid: slot.bucketid,
    mimetype: file.type || "image/jpeg",
    fileversion: slot.fileversion
  });
}
